
import React, { useRef, useState } from 'react'
import { Input, Button, Checkbox, Spinner, Switcher, Tooltip, Badge, Select } from 'components/ui'
import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'
import { HiOutlinePlusCircle, HiOutlineMinusCircle, HiOutlineTrash, HiOutlineExclamation } from 'react-icons/hi'
import { formatterInputSelectData } from 'utils/storeHube/helpers'
import { filterVisibleQuestions, guidGenerator, handleNameChange, handleOptionChange, onCheckRequired, removeInvisibleOptions, setOptionIncident, setOptionPenality } from './helpers'
import { FiSave } from 'react-icons/fi'
import AnswerField from './AnswerField'

const QuestionTypeCheckBox = ({ handleAddNewQuestion, questionTypeId, question, edit, handleRemoveQuestion, isAnswer, questionForAnswer, onChange, createAnswers, errorMessage, defaultValue = [], renderAfterOption }) => {

  const { t } = useTranslation()

  const [newOptionEdit, setNewOptionEdit] = useState(false)
  const [optionList, setOptionList] = useState(question ? formatterInputSelectData(question.question_option) : [])
  const [nameQuestion, setNameQuestion] = useState(question ? question.name : "")
  const [uniqueUuid, setUniqueUuid] = useState(question ? (question.uuid || question.uuid2) : "")
  const [optionListModified, setOptionListModified] = useState(question ? question.question_option : [])
  const [questionType_id, setQuestionTypeId] = useState(question ? question.question_type_id : questionTypeId)
  const [questionRequired, setQuestionRequired] = useState(question ? question.required : false)
  const [loading, setLoading] = useState(false)
  const [questionTag, setQuestionTag] = useState(question && question.tags ? question.tags[0] : null)
  const [points, setPoints] = useState(0)
  const [selectedPoints, setSelectedPoints] = useState(null);
  const [questionPoints, setQuestionPoints] = useState(question ? question.points : 0)
  const [isRemoving, setIsRemoving] = useState(false)

  const inputRef = useRef(null)

  console.log(question)
  
  useEffect(() => {
    if (newOptionEdit) {
      inputRef.current.focus()
    }
  }, [newOptionEdit])

  // FUNCIÓN ORIGINAL: Marca como invisible (tu lógica original)
  const removeOption = (option) => {
    const modifiedOption = { ...option, visible: false };
    const newOptionList = optionList.filter((item) => item.label !== option.label);
    newOptionList.push(modifiedOption);
    setOptionList(newOptionList);
    setOptionListModified(newOptionList);
  };

  const onNewOptionAdd = () => {
    const newUuid2 = guidGenerator();
    const newOption = {
      name: inputRef.current.value,
      label: inputRef.current.value,
      checked: false,
      visible: true,
      points: points,
      uuid2: newUuid2,
      incidents: false, // Inicializar explícitamente
      penality: false,  // Inicializar explícitamente
      priority: 0       // Inicializar explícitamente
    };
    
    const newOptionModified = {
      name: inputRef.current.value,
      uuid2: newUuid2,
      points: points,
      incidents: false,
      penality: false,
      priority: 0
    };
    
    setOptionList(prevOption => [...prevOption, newOption]);
    setOptionListModified(prevOption => [...prevOption, newOptionModified]);
    setNewOptionEdit(false);
    inputRef.current.value = "";
  }

  // FUNCIÓN CORREGIDA: Usar ID único en lugar de índice
  const onOptionCheckChange = (checked, optionId) => {
    setOptionList(prevOption => {
      const mutatedPrevOption = prevOption.map((option) => {
        const currentOptionId = option.uuid || option.uuid2;
        if (currentOptionId === optionId) {
          return { ...option, checked: checked };
        }
        return option;
      });
      return mutatedPrevOption;
    });
  }

  // FUNCIÓN CORREGIDA para manejar cambios en opciones
  const handleOptionChangeLocal = (e, id, field) => {
    let formattedValue = e.target.value;
    
    if (field === 'points') {
        formattedValue = formattedValue.replace(/[^0-9.]/g, ''); 
        const pointCount = (formattedValue.match(/\./g) || []).length;
        
        if (pointCount > 1) {
            formattedValue = formattedValue.replace(/\.+$/, '');
        }

        const decimalPart = formattedValue.split('.')[1];
        if (decimalPart && decimalPart.length > 2) {
            formattedValue = formattedValue.slice(0, formattedValue.indexOf('.') + 3);
        }
    } else if (field === 'priority') {
        formattedValue = formattedValue.replace(/[^0-9]/g, '');
    }

    if (formattedValue === '' || formattedValue === null) {
        formattedValue = '0';
    }

    const updateOptions = (prevOptions) => {
        return prevOptions.map((option) => {
            const optionId = option.uuid || option.uuid2;
            if (optionId === id) {
                return { ...option, [field]: formattedValue };
            }
            return option;
        });
    };

    setOptionList(updateOptions);
    setOptionListModified(updateOptions);
  };

  // FUNCIÓN CORREGIDA para manejar incidencias
  const setOptionIncidentLocal = (checked, optionId) => {
    const updateOptions = (prevOptions) => {
      return prevOptions.map((option) => {
        const currentOptionId = option.uuid || option.uuid2;
        if (currentOptionId === optionId) {
          return { ...option, incidents: checked };
        }
        return option;
      });
    };

    setOptionList(updateOptions);
    setOptionListModified(updateOptions);
  };

  // FUNCIÓN CORREGIDA para manejar penalizaciones
  const setOptionPenalityLocal = (checked, optionId) => {
    const updateOptions = (prevOptions) => {
      return prevOptions.map((option) => {
        const currentOptionId = option.uuid || option.uuid2;
        if (currentOptionId === optionId) {
          return { ...option, penality: checked };
        }
        return option;
      });
    };

    setOptionList(updateOptions);
    setOptionListModified(updateOptions);
  };

  const updateQuestions = () => {
    setLoading(true)
    handleAddNewQuestion(nameQuestion, optionList, questionType_id, questionRequired, uniqueUuid, undefined, undefined, questionPoints)
    setPoints(0)
    setSelectedPoints(null)
    setTimeout(() => {
      setLoading(false)
    }, 1000);
  }

  useEffect(() => {
    !isAnswer && updateQuestions()
  }, [optionListModified, nameQuestion, questionRequired, optionList, questionPoints])

  const [values, setValues] = useState(defaultValue)

  return (
    <>
      {
        isAnswer ?
          <AnswerField
            label={questionForAnswer?.name}
            required={questionForAnswer?.required}
            error={errorMessage}
          >
            {
              questionForAnswer?.question_option?.length > 0 &&
              <Checkbox.Group
                vertical
                className="w-full"
                value={values}
                onChange={e => {
                  setValues(e)
                  const val = e.length > 0 ? JSON.stringify(e) : undefined
                  onChange(val)
                }}
              >
                {/* `renderAfterOption`: ver el comentario en `QuestionTypeRadio`. El
                    `Group` reparte el estado por contexto y no clona a sus hijos, asi que
                    intercalar un nodo entre los `Checkbox` es seguro. */}
                {filterVisibleQuestions(questionForAnswer.question_option).map((option) => {
                  const rama = renderAfterOption?.(option)
                  return (
                    <React.Fragment key={option.uuid || option.uuid2 || option.id}>
                      <Checkbox value={option.id}>
                        {option.name}
                      </Checkbox>
                      {rama && (
                        <div className="mt-3 mb-2 ml-1 pl-4 pb-1 border-l-2 border-indigo-200 dark:border-indigo-800/70 space-y-4">
                          {rama}
                        </div>
                      )}
                    </React.Fragment>
                  )
                })}
              </Checkbox.Group>
            }
          </AnswerField>
          :
          <>
            <Input onChange={(event) => handleNameChange(setNameQuestion, event)} placeholder={t("question")} value={nameQuestion} />
            {edit && questionTag &&
              <div className=" flex items-center mr-2 rtl:ml-2 mt-3 gap-2">
                <p className=' capitalize '>{t("tag")} : </p>
                <div className="flex items-center gap-2 border rounded-lg px-1">
                  <Badge style={{ "backgroundColor": `${questionTag.color}` }} />
                  <span className={`capitalize font-semibold `}>
                    {questionTag.name}
                  </span>
                </div>
              </div>
            }
            {
              optionList.length > 0 &&
              <div className="flex flex-col ">
                <div className='mt-4'>
                  {removeInvisibleOptions(optionList).map((option) => {
                    const optionId = option.uuid || option.uuid2;
                    return (
                      <div key={optionId} className="flex flex-col sm:flex-row items-start sm:items-center justify-start sm:justify-between mb-5 ">
                        <div className="flex flex-row items-center justify-between">
                          <div className='mr-5 ' onClick={() => removeOption(option)}>
                            <HiOutlineMinusCircle className=' text-lg ' />
                          </div>

                          <Checkbox
                            key={`checkbox-${optionId}`} // CLAVE ÚNICA PARA CHECKBOX
                            defaultChecked={option.checked}
                            className="flex flex-row "
                            onChange={checked => onOptionCheckChange(checked, optionId)} // USAR ID EN LUGAR DE ÍNDICE
                          >
                            {option.label}
                          </Checkbox>
                          
                          <div className=' ml-2 h-6 flex items-center gap-2 text-center'>
                            Puntos:
                            <input
                              type="text"
                              className="input h-6 w-[60px] border border-gray-300 p-2 rounded text-center"
                              onChange={(e) => handleOptionChangeLocal(e, optionId, 'points')}
                              value={option.points || 0}
                            />

                            Orden:
                            <input
                              type="text"
                              className="input h-6 w-[40px] border border-gray-300 p-2 rounded text-center"
                              onChange={(e) => handleOptionChangeLocal(e, optionId, 'priority')}
                              value={option.priority || 0}
                              placeholder="Priority"
                            />
                          </div>

                          <div className='mr-5 mt-2 '>
                            <Tooltip title={t("message_incidence")}>
                              {option.incidents && <HiOutlineExclamation className=' text-lg ' />}
                            </Tooltip>
                          </div>
                        </div>
                        
                        <div className="flex flex-wrap gap-3 items-end" >
                          <div className='flex items-center mr-2'>
                            <span className='mr-2'> {t("check_incidence")}</span>
                            <Switcher 
                              key={`incidents-${optionId}`} // CLAVE ÚNICA
                              defaultChecked={option.incidents} 
                              onChange={(checked) => setOptionIncidentLocal(checked, optionId)} 
                            />
                          </div>
                          {
                            option.incidents &&
                            <div className='flex items-center mr-2 '>
                              <span className='mr-2'> {t("check_penality")}</span>
                              <Switcher 
                                key={`penality-${optionId}`} // CLAVE ÚNICA
                                defaultChecked={option.penality} 
                                onChange={(checked) => setOptionPenalityLocal(checked, optionId)} 
                              />
                            </div>
                          }
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            }
            <>
              <div className="flex items-center gap-2 mt-2">
                <Input ref={inputRef} placeholder={t("question_options")} />
              </div>
             
              <div className="flex items-center gap-2 my-3">
                <Button type="button" onClick={onNewOptionAdd} icon={<HiOutlinePlusCircle />}></Button>
              </div>

              <div className='flex items-center mb-3 justify-end'>
                <div className='flex items-center mr-2'>
                  <span className='mr-2'>{t("question_points")}:</span>
                  <input
                    type="text"
                    className="input h-8 w-[80px] border border-gray-300 p-2 rounded text-center"
                    value={questionPoints}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9.]/g, '');
                      setQuestionPoints(value === '' ? 0 : value);
                    }}
                    placeholder="0"
                  />
                </div>
                <div className='flex items-center mr-2'>
                  <span className='mr-2'> {t("isRequired")}</span>
                  <Switcher defaultChecked={question && question.required} onChange={(event) => onCheckRequired(setQuestionRequired, event)} />
                </div>
                {
                  edit &&
                  <>
                    <div
                      className={`mr-5 cursor-pointer transition-colors duration-200 ${isRemoving ? 'text-gray-400 pointer-events-none' : 'hover:text-red-500'}`}
                      onClick={() => {
                        setIsRemoving(true)
                        setTimeout(() => handleRemoveQuestion(question), 600)
                      }}
                    >
                      <Tooltip title={isRemoving ? "Desactivando pregunta..." : "Desactivar pregunta"}>
                        {isRemoving ? <Spinner size={20} /> : <HiOutlineTrash className=' text-lg ' />}
                      </Tooltip>
                    </div>
                    <div className='mr-5' onClick={() => updateQuestions()}>
                      <Tooltip title="Guardar cambios">
                        {loading ? <Spinner /> : <FiSave className=' text-lg ' />}
                      </Tooltip>
                    </div>
                  </>
                }
              </div>
              {
                !edit && <Button
                  block
                  className="border-dashed mb-3"
                  onClick={() => handleAddNewQuestion(nameQuestion, optionListModified, questionTypeId, questionRequired, uniqueUuid)}
                >
                  {t("save_question")}
                </Button>
              }
            </>
          </>
      }
    </>
  )
}

export default QuestionTypeCheckBox
